/* Newbe — Cart drawer
   Opens from the header cart icon and after add-to-cart (nbc:add event from
   newbe-pdp.js). Quantity/remove go through the AJAX Cart API, then the drawer
   re-renders itself via the Section Rendering API so prices/images stay correct.
   Mirrors the existing mobile-drawer open/close pattern (.open + scrim + body lock). */
(function () {
  'use strict';

  var drawer = document.getElementById('nbc-drawer');
  var scrim = document.getElementById('nbc-scrim');
  if (!drawer || !scrim) return;

  var sectionId = drawer.getAttribute('data-section-id');
  var busy = false;

  function open() {
    drawer.classList.add('open');
    scrim.classList.add('open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }
  function close() {
    drawer.classList.remove('open');
    scrim.classList.remove('open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  /* ---- open triggers ---- */
  // cart icon (delegated — icon lives outside the drawer)
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-nbc-open]');
    if (trigger) { e.preventDefault(); open(); }
  });
  // add-to-cart dispatches this (see newbe-pdp.js)
  document.addEventListener('nbc:add', function () {
    refresh().then(open);
  });

  /* ---- close triggers ---- */
  scrim.addEventListener('click', close);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer.classList.contains('open')) close();
  });

  /* ---- delegated actions inside the drawer (survive innerHTML swaps) ---- */
  drawer.addEventListener('click', function (e) {
    if (e.target.closest('[data-nbc-close]')) { close(); return; }

    var qty = e.target.closest('[data-nbc-qty]');
    if (qty) {
      change(qty.getAttribute('data-nbc-qty'), parseInt(qty.getAttribute('data-nbc-to'), 10));
      return;
    }
    var rm = e.target.closest('[data-nbc-remove]');
    if (rm) { change(rm.getAttribute('data-nbc-remove'), 0); return; }
  });

  /* ---- cart mutations ---- */
  function change(key, quantity) {
    if (busy || quantity == null || isNaN(quantity) || quantity < 0) return;
    busy = true;
    drawer.classList.add('nbc-loading');
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(function () { return refresh(); })
      .catch(function () {})
      .then(function () { busy = false; drawer.classList.remove('nbc-loading'); });
  }

  /* ---- re-render the drawer + header count from the server ---- */
  function refresh() {
    var url = location.pathname + '?section_id=' + encodeURIComponent(sectionId);
    return fetch(url, { headers: { Accept: 'text/html' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.getElementById('nbc-drawer');
        if (fresh) drawer.innerHTML = fresh.innerHTML;

        // sync the header count bubble(s)
        var freshCount = doc.querySelector('.cartbtn .count');
        document.querySelectorAll('.cartbtn').forEach(function (btn) {
          var current = btn.querySelector('.count');
          if (freshCount) {
            if (current) current.textContent = freshCount.textContent;
            else btn.insertAdjacentHTML('beforeend', freshCount.outerHTML);
          } else if (current) {
            current.remove();
          }
        });
      })
      .catch(function () {});
  }
})();
